import { useMediaQuery } from 'react-responsive';
import { theme } from '@dls/web';

const { xs, sm, md, lg, xl } = theme.breakpoints;

const useCustomizedMediaQuery = () => {
  const isXS = useMediaQuery({ minWidth: 0, maxWidth: xs });
  const isSM = useMediaQuery({ minWidth: xs, maxWidth: sm });
  const isMD = useMediaQuery({ minWidth: sm, maxWidth: md });
  const isLG = useMediaQuery({ minWidth: md, maxWidth: lg });
  const isXL = useMediaQuery({ minWidth: lg, maxWidth: xl });

  const isMaxXS = useMediaQuery({ maxWidth: xs });
  const isMaxSM = useMediaQuery({ maxWidth: sm });
  const isMaxMD = useMediaQuery({ maxWidth: md });
  const isMaxLG = useMediaQuery({ maxWidth: lg });
  const isMaxXL = useMediaQuery({ maxWidth: xl });

  return {
    isXS,
    isSM,
    isMD,
    isLG,
    isXL,
    isMaxXS,
    isMaxSM,
    isMaxMD,
    isMaxLG,
    isMaxXL
  };
};

export default useCustomizedMediaQuery;
